export default __webpack_public_path__ + "static/media/ico_15.1e5f6d22.png";